/**
 * Expo Router types a query param as `string | string[]`, since the same key can repeat in the
 * URL. Call sites that only ever expect one value use this to take the first.
 */
export const getFirstSearchParam = (value: string | string[] | undefined): string | undefined =>
  typeof value === 'string' ? value : value?.[0];
